/**
 * ScopeBreadcrumb
 *
 * Small chip rendered at the top of the Expenses page when the topbar
 * ChildScope is locked to a specific child. Explains "you're only
 * seeing Child X's expenses" and offers a one-tap path back to the
 * All-children rollup. Hidden in All-children mode (would be noise).
 *
 * Extracted from pages/Expenses.jsx in the v77.99.19 Phase 3 frontend
 * decomposition pass. Behaviour preserved verbatim.
 *
 * Props:
 *  - selectedChildId: string | null
 *  - childList:       [{ id, name, color }]
 *  - onClear:         () => void   (sets ChildScope back to null)
 */
export function ScopeBreadcrumb({ selectedChildId, childList, onClear }) {
  if (!selectedChildId) return null;
  const scopedChild = (childList || []).find((c) => c.id === selectedChildId);
  if (!scopedChild) return null;
  return (
    <div
      className="flex items-center gap-2 px-3 py-2 bg-[#F4FAFA] border border-[#D6F0EF] rounded-sm text-sm text-[#2E3A3F]"
      data-testid="expenses-scope-breadcrumb"
    >
      <span
        className="w-2 h-2 rounded-full flex-shrink-0"
        style={{ backgroundColor: scopedChild.color || "#1F9FA4" }}
      />
      <span className="flex-1 min-w-0 truncate">
        Viewing <span className="font-medium">{scopedChild.name}</span>&apos;s expenses only.
      </span>
      <button
        type="button"
        onClick={onClear}
        className="text-xs text-[#116B6E] hover:text-[#0F5658] underline-offset-2 hover:underline whitespace-nowrap"
        data-testid="expenses-scope-switch-view"
      >
        Switch to all children
      </button>
    </div>
  );
}

export default ScopeBreadcrumb;
